<template>
  <div class="mapa-container">
    <h2 class="mapa-title">Localização</h2>
    <div class="mapa-content">
      <!-- Card com as informações de localização -->
      <v-card class="endereco-card" elevation="3">
        <v-card-text>
          <div class="endereco-header">
            <v-icon size="32" color="primary" class="location-icon">mdi-map-marker</v-icon>
            <h3 class="endereco-title">Endereço Completo</h3>
          </div>
          <div class="endereco-detalhes">
            <div class="endereco-item">
              <v-icon color="secondary">mdi-road-variant</v-icon>
              <span class="endereco-text">{{ rua }}, {{ numero }}</span>
            </div>
            <div class="endereco-item">
              <v-icon color="secondary">mdi-home-city-outline</v-icon>
              <span class="endereco-text">{{ bairro }}</span>
            </div>
            <div class="endereco-item">
              <v-icon color="secondary">mdi-map-outline</v-icon>
              <span class="endereco-text">{{ cidade }} - {{ estado }}</span>
            </div>
            <div class="endereco-item">
              <v-icon color="secondary">mdi-mailbox</v-icon>
              <span class="endereco-text">CEP: {{ cep }}</span>
            </div>
          </div>
          <v-btn
            color="primary"
            block
            class="mt-4"
            :href="googleMapsUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon left>mdi-google-maps</v-icon>
            Ver no Google Maps
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Mapa do Google Maps -->
      <div class="map-wrapper">
        <GMapMap
          :center="{ lat: latitude, lng: longitude }"
          :zoom="15"
          map-type-id="roadmap"
          class="google-map"
        >
          <GMapMarker :position="{ lat: latitude, lng: longitude }">
            <GMapInfoWindow :opened="true">
              <div class="info-window">
                <strong>{{ rua }}, {{ numero }}</strong>
                <p>{{ bairro }}, {{ cidade }} - {{ estado }}</p>
              </div>
            </GMapInfoWindow>
          </GMapMarker>
        </GMapMap>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapaImovelComponent",
  props: {
    latitude: {
      type: Number,
      required: true,
    },
    longitude: {
      type: Number,
      required: true,
    },
    rua: {
      type: String,
      required: true,
    },
    numero: {
      type: String,
      required: true,
    },
    bairro: {
      type: String,
      required: true,
    },
    cidade: {
      type: String,
      required: true,
    },
    estado: {
      type: String,
      required: true,
    },
    cep: {
      type: String,
      required: true,
    },
  },
  computed: {
    googleMapsUrl() {
      const address = encodeURIComponent(
        `${this.rua}, ${this.numero}, ${this.bairro}, ${this.cidade}, ${this.estado}`
      );
      return `https://www.google.com/maps/search/?api=1&query=${address}`;
    },
  },
};
</script>

<style scoped>
.mapa-container {
  margin: 2rem auto;
  padding: 0 1rem;
  max-width: 1400px;
}

.mapa-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--v-primary-base);
  padding-left: 12px;
}

.mapa-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  align-items: start;
}

.endereco-card {
  height: 100%;
  background-color: white;
  border-radius: 12px;
}

.endereco-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.location-icon {
  margin-right: 1rem;
}

.endereco-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--v-primary-base);
  margin: 0;
}

.endereco-detalhes {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.endereco-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.endereco-text {
  font-size: 1rem;
  color: var(--v-secondary-base);
}

.map-wrapper {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.google-map {
  width: 100%;
  height: 100%;
}

.info-window {
  padding: 0.5rem;
  text-align: center;
}

.info-window strong {
  display: block;
  margin-bottom: 0.25rem;
}

.info-window p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--v-secondary-base);
}

@media (max-width: 959px) {
  .mapa-content {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .map-wrapper {
    height: 400px;
  }

  .endereco-card {
    order: -1;
  }
}

@media (max-width: 600px) {
  .mapa-container {
    margin: 1.5rem 0;
  }

  .mapa-title {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }

  .map-wrapper {
    height: 300px;
  }

  .endereco-title {
    font-size: 1.1rem;
  }

  .endereco-text {
    font-size: 0.9rem;
  }
}
</style>